import * as React from 'react';
import { observer } from 'mobx-react';

import { DialogRoute } from 'bernie-core';
import { Layer } from 'bernie-view';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLink } from 'uitk-react-link';
import { UitkText } from 'uitk-react-text';
import { UitkNotificationBadge1 } from 'uitk-react-badge';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

import { ButtonTracked } from 'components/shared';
import { useStores } from 'utility/hooks';
import { SortFilterDialog } from 'components/search/sort-filter';

export const SortFilterTrigger = observer(() => {
  const { sortFilterStore, searchFormStore, routeStore } = useStores();
  const revealActionAnalytics = sortFilterStore && sortFilterStore.revealActionAnalytics;
  const revealAction = sortFilterStore && sortFilterStore.revealAction;
  const appliedFilterCount = (revealAction && revealAction.appliedFilterCount) || 0;
  const showNumberOfActiveFilters = appliedFilterCount > 0;
  const shouldEnableSortFilterButton = revealAction && revealAction.enabled;
  const iconAndLabel = revealAction && revealAction.iconAndLabel;
  const iconId = (iconAndLabel && iconAndLabel.icon && iconAndLabel.icon.id) || 'tune';
  const label = iconAndLabel && iconAndLabel.label;
  const sortFilterDialogId = 'sort-filter-dialog';

  const sortFilterDialogQuery = routeStore.mergeQueryString(routeStore.search, {
    pwaDialog: sortFilterDialogId
  });

  const onSortFilterDialogDismiss = React.useCallback(() => {
    searchFormStore.restoreSearchFormToInitialState();
    routeStore.closeDialog('pwaDialog');
  }, [routeStore, searchFormStore]);

  const openSortAndFilterDialog = React.useCallback(() => {
    searchFormStore.restoreSearchFormToInitialState();
    routeStore.updateSearch(sortFilterDialogQuery);
  }, [routeStore, searchFormStore, sortFilterDialogQuery]);

  return (
    <div data-test-id={`${sortFilterDialogId}-trigger`}>
      <UitkLink>
        <ButtonTracked
          onClick={openSortAndFilterDialog}
          disabled={!shouldEnableSortFilterButton}
          {...revealActionAnalytics}
        >
          <UitkLayoutFlex space="two" alignItems="center">
            <>
              <UitkLayoutFlexItem>
                {showNumberOfActiveFilters ? (
                  <UitkNotificationBadge1 text={appliedFilterCount.toString()} />
                ) : (
                  <UitkIcon name={iconId} size={UitkIconSize.SMALL} />
                )}
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem>
                <UitkText size={400} inline={true} weight="medium">
                  {label}
                </UitkText>
              </UitkLayoutFlexItem>
            </>
          </UitkLayoutFlex>
        </ButtonTracked>
      </UitkLink>
      <DialogRoute id={sortFilterDialogId}>
        <Layer id={`${sortFilterDialogId}-layer`}>
          <SortFilterDialog
            onDismiss={onSortFilterDialogDismiss}
            sortAndFilterResult={sortFilterStore}
            dialogId={sortFilterDialogId}
          />
        </Layer>
      </DialogRoute>
    </div>
  );
});
